import { categories } from "@/mocks/chigua";

export default function Categories() {
  return (
    <section id="category" className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-800">
            <i className="ri-shapes-fill" aria-hidden="true"></i> 想看什么瓜
          </p>
          <h2 className="mt-3 font-display text-3xl text-foreground-900 md:text-4xl">现场分类</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            按主题分类浏览,精准找到你感兴趣的那一趴现场
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4">
          {categories.map((c, idx) => (
            <a
              key={c.id}
              href="#feed"
              className="group flex items-center gap-4 rounded-2xl border border-secondary-200 bg-background-50 p-5 transition hover:border-primary-300 hover:bg-white"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-2xl ${
                  idx % 2 === 0
                    ? "bg-primary-100 text-primary-600"
                    : "bg-accent-100 text-accent-700"
                }`}
              >
                <i className={c.icon} aria-hidden="true"></i>
              </span>
              <div className="min-w-0">
                <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-700">
                  {c.name}
                </h3>
                <p className="mt-0.5 truncate text-xs text-foreground-500">{c.desc}</p>
                <p className="mt-1 text-xs font-semibold text-primary-600">{c.count}</p>
              </div>
              <i
                className="ri-arrow-right-s-line ml-auto text-xl text-foreground-300 group-hover:text-primary-500"
                aria-hidden="true"
              ></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}